export default "__VITE_ASSET__DCHZIb0o__"